import * as types from '../store/mutation-types'
import { parseTimeToString } from './time'

function getPackageDate (rPackage, showLocalTZ) {
  const date = rPackage.date_publication ? rPackage.date_publication : rPackage.package_date
  return parseTimeToString(date, showLocalTZ)
}

async function fetchPackages (HTTP, commit, url) {
  let response
  try {
    response = await HTTP.get(url)
  } catch (err) {
    if (err.response.status === 400 && err.response.data.code === 23) {
      // there are no subscriptions for the repo
      commit(types.SET_NO_SUBSCRIPTIONS_FOR_REPO, true)
    }
    commit(types.SET_GETTING_PACKAGES, -1)
  }
  return response
}

export const packageUtils = {
  getPackageDate,
  fetchPackages,
}
